<div class="profile__wrapper d-flex">
  <div class="salary">
    <h2 class="salary__h2">Increase history</h2>
    <div class="salary__historyTable" *ngIf="dataSalary.length; else nosalary">
      <app-table
        [tableType]="'material'"
        [headers]="headersCertHistory"
        [content]="dataSalary"
      ></app-table>
    </div>
    <ng-template #nosalary>
      <div class="profile__nodata">
        There is no increase history for that employee
      </div>
    </ng-template>
    <h2 class="salary__h2">Accumulated vacation days</h2>
    <div class="salary__vacationDays" *ngIf="dataVacation; else novacation">
      <app-table
        [tableType]="'material'"
        [headers]="headersCertVacation"
        [content]="dataVacation"
        [showEditFields]="isAccountant"
        [editLastTwoRows]="isAccountant"
        [editMenu]="'icon'"
        (rowAction)="showDialog($event)"
      ></app-table>
    </div>
    <ng-template #novacation>
      <div class="profile__nodata">
        There is no accumulated vacation history for that employee
      </div>
    </ng-template>
  </div>
  <div class="salary__detailed" *ngIf="isAccountant">
    <button
      class="button button__generate-reports mt-16"
      (click)="goToSalaryRoute()"
    >
      View detailed salary
    </button>
  </div>
</div>
